import './App.css';
import HeroSection from './components/HeroSection';
import About from './components/AboutSection';
import Header from './components/Header';
import ServicesSection from './components/ServicesSection';
import Team from './components/Team';  
import ApplicationsSection from './components/ApplicationSection';
import QualitySection from './components/QualitySection';
import PartnershipSection from './components/PartnershipSection';
import EquipmentSection from './components/EquipmentSection';
import ContactSection from './components/ContactSection';

function App() {
  return (
    <div className="App">
      <Header />
      <div className="pt-16"> {/* Add padding to prevent content from being hidden behind the fixed header */}
        <HeroSection />
        <About />
        <ServicesSection />
        <Team />
        <ApplicationsSection />
        <QualitySection />
        <PartnershipSection />
        <EquipmentSection />
        <ContactSection />
      </div>
    </div>
  );
}

export default App;